import { render, staticRenderFns } from "./DataTableWrapper.vue?vue&type=template&id=69f1446b&scoped=true"
import script from "./DataTableWrapper.vue?vue&type=script&lang=ts"
export * from "./DataTableWrapper.vue?vue&type=script&lang=ts"
import style0 from "./DataTableWrapper.vue?vue&type=style&index=0&id=69f1446b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f1446b",
  null
  
)

export default component.exports